import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const stats = [
    { value: '22', label: t.hero.statsMatches },
    { value: '5', label: t.hero.statsGoals },
    { value: '3', label: t.hero.statsAssists },
    { value: '34.0', label: t.hero.statsSpeed }
  ];

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden py-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black z-10" />
        <img
          src="https://customer-assets.emergentagent.com/job_futbolista-tomas/artifacts/6k3zfvff_IMG_4548.jpeg"
          alt="Tomás Roco - Universidad de Concepción"
          className="w-full h-full object-cover"
          style={{ objectPosition: 'center 35%' }}
        />
      </div>

      {/* Content */}
      <div className="relative z-20 text-center px-4 max-w-6xl mx-auto">
        <div className="animate-fade-in-up">
          <h1
            className="text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-bold mb-6 tracking-wider"
            style={{ fontFamily: 'Bebas Neue, sans-serif' }}
          >
            TOMÁS ROCO
          </h1>
          
          <div className="flex items-center justify-center gap-3 mb-8">
            <div className="h-px w-12 bg-red-600" />
            <p 
              className="text-lg sm:text-xl md:text-2xl text-gray-200 max-w-4xl" 
              style={{ fontFamily: 'Oswald, sans-serif' }}
            >
              {t.hero.position}
            </p>
            <div className="h-px w-12 bg-red-600" />
          </div>

          {/* Descriptions */}
          <div className="max-w-4xl mx-auto space-y-4 mb-8">
            <p 
              className="text-base sm:text-lg text-gray-300 leading-relaxed"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {t.hero.description}
            </p>
            <p 
              className="text-base sm:text-lg text-gray-300 leading-relaxed"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {t.hero.description2}
            </p>
          </div>

          {/* Stats destacados */}
          <div className="mb-8">
            <h3 
              className="text-xl sm:text-2xl font-bold mb-6 text-red-600"
              style={{ fontFamily: 'Oswald, sans-serif' }}
            >
              {t.hero.statsTitle}
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
              {stats.map((stat, index) => (
                <div 
                  key={index}
                  className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 hover:border-red-600/50 transition-all duration-300"
                >
                  <p 
                    className="text-3xl sm:text-4xl font-bold text-red-600 mb-1"
                    style={{ fontFamily: 'Bebas Neue, sans-serif' }}
                  >
                    {stat.value}
                  </p>
                  <p 
                    className="text-xs sm:text-sm text-gray-400"
                    style={{ fontFamily: 'Poppins, sans-serif' }}
                  >
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={scrollToAbout}
            className="mt-6 px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-red-600/50"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            {t.hero.cta}
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToAbout}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 text-white/80 hover:text-white transition-colors animate-bounce"
      >
        <span className="text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>{t.hero.scroll}</span>
        <ChevronDown size={24} />
      </button>
    </section>
  );
};

export default Hero;
